<template>
  <div class="preferences">
    <h2 class="title is-3">{{ $t("Preferences") }}</h2>
    <db-settings />
    <share-account-access v-if="shouldOfferShareAccess" />
    <preferences />
  </div>
</template>

<script>
import Vue from "vue";
import DbSettings from "@/components/DbSettings";
import Preferences from "@/components/Preferences";
import ShareAccountAccess from "@/components/ShareAccountAccess";

export default Vue.extend({
  name: "settings",
  data: function () {
    return {};
  },
  computed: {
    shouldOfferShareAccess() {
      return this.$store.state.dbUrl !== "";
    },
  },
  components: {
    DbSettings,
    Preferences,
    ShareAccountAccess,
  },
});
</script>

<style scoped>
.db-settings,
.share-account-access {
  margin-bottom: 1.5rem;
}
</style>
<i18n>
{
  "en": {},
  "de": {
    "Preferences": "Einstellungen",
    "Share Meal Planner": "Meal Planner teilen",
    "I'm using this to plan my shopping.": "Damit plane ich meine Einkäufe."
  }
}
</i18n>
